import { useContext } from 'react';
import NotificationContext from 'src/contexts/notification/notificationContext';

const useNotification = () => useContext(NotificationContext);

export default useNotification;
